import styled from 'styled-components';

import { Divider } from '@amzn/monera-app-core-components';

export const ParentWrapperContainer = styled.div`
  display: flex;
  flex: 1;
  margin: auto;
  position: absolute;
  left: 0;
  right: 0;
  max-width: 1500px;
  min-width: 1000px;
  padding-right: 60px;
`;

export const LeftDummyContainer = styled.div`
  display: flex;
  flex: 1;
`;

export const BuyBoxContainer = styled.div`
  z-index: 2;
  background-color: #ffffff;
  border: 1px solid #d5d9d9;
  border-radius: 18px;
  flex-direction: column;
  width: calc(40%);
  max-width: 600px;
  min-width: 400px;
  margin-top: 40px;
  padding: 4px 24px 0px 24px;
`;

export const StyledDivider = styled(Divider)`
  width: auto;
  height: 1px;
`;

export const MobileBuyBoxContainer = styled.div``;
